<template>
  <div class="allSearch">
    <el-form class="search-form">
      <el-form-item label="所在城市：">
        <CascaderArea
          :country="queryInfo.personCountry"
          :province="queryInfo.personProvince"
          :city="queryInfo.personCity"
          @searchArae="searchCurrentArae"
        />
      </el-form-item>
      <el-form-item label="期望地点：">
        <CascaderArea
          :country="queryInfo.expectedCountry"
          :province="queryInfo.expectedProvince"
          :city="queryInfo.expectedCity"
          @searchArae="searchArae"
        />
      </el-form-item>
      <el-form-item label="工作经验：">
        <radio-select :code.sync="queryInfo.workingYears" type-code="003" @onChange="onChange" />
      </el-form-item>
      <el-form-item label="职位类型：">
        <multiSelect
          typeCode="008"
          @change="changePositionType"
          :code.sync="queryInfo.personTypes"
        />
      </el-form-item>
    </el-form>
    <div class="search-input">
      <el-input
        placeholder="请输入关键词"
        v-model="queryInfo.name"
        clearable
        class="input-with-select"
      >
        <el-button slot="append" icon="el-icon-search" @click="search" />
      </el-input>
    </div>
    <div class="talents">
      共匹配到<span class="total">{{ total }} </span>
      条人才信息
    </div>
    <table-info
      :tableInfo="allSearchTable"
      :total="total"
      :queryInfo="queryInfo"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template #controlBtn="slotProps">
        <div class="btn-control">
          <icon-and-button
            title="发起聊天"
            icon="icon-jr-icon-tidings"
            @handleControl="handleControl"
          />
          <icon-and-button
            title="添加到沟通列表"
            icon="icon-jr-icon-people"
            :extraInfo="{ personCode: slotProps.childInfo.personCode }"
            @handleControl="handleControl"
          />
          <icon-and-button
            title="查看详情"
            icon=""
            :buttonStyle="{ color: '#17757A' }"
            :extraInfo="{ personCode: slotProps.childInfo.personCode }"
            @handleControl="handleControl"
          />
        </div>
      </template>
    </table-info>
  </div>
</template>

<script>
import { getMatch, addToCommunication } from '@/api/projectCenter'
import IconAndButton from '@/components/IconAndButton.vue'
import tableInfo from '../cpns/tableInfo.vue'
import CascaderArea from '@/components/CascaderArea.vue'
import MultiSelect from '@/components/MultiSelect.vue'
import RadioSelect from '@/components/RadioSelect.vue'

export default {
  props: {
    positionType: {
      type: String
    },
    id: {
      type: Number
    },
    tabName: {
      type: String
    },
    searchInfo: {
      type: Object
    }
  },

  components: {
    IconAndButton,
    tableInfo,
    CascaderArea,
    RadioSelect,
    MultiSelect
  },

  data() {
    return {
      queryInfo: {
        baseParam: {
          pageNum: 1, //页数
          pageSize: 30 //大小
        },
        name: '', // 关键词
        personCountry: '', // 所在国家
        personProvince: '', // 所在省份
        personCity: '', // 所在城市
        expectedCountry: '', // 期望国家
        expectedProvince: '', // 期望省份
        expectedCity: '', // 期望城市
        workingYears: '', // 工作经验
        personTypes: [] // 职位类型
      },
      allSearchTable: [],
      total: 0 // 条数
    }
  },

  watch: {
    tabName: {
      handler: function (newVal) {
        if (newVal === 'second') {
          if (Object.keys(this.$store.state.projectCenter.allSearchQueryInfo).length) {
            Object.keys(this.$store.state.projectCenter.allSearchQueryInfo).forEach((item) => {
              this.queryInfo[item] = this.$store.state.projectCenter.allSearchQueryInfo[item]
            })
          }
          this.search()
        }
      },
      immediate: true
    }
  },

  methods: {
    // 查询
    async search() {
      const { data: res } = await getMatch(this.queryInfo)
      if (res.resultCode === 200) {
        this.allSearchTable = res.data.content
        this.total = res.data.totalElements
        this.allSearchTable.forEach((item) => {
          if (item.personExperience) {
            // this.clientTableData[index].personExperience =
            item.personExperience.reverse()
          }
        })
      }
    },
    handleCurrentChange(newPage) {
      this.queryInfo.baseParam.pageNum = newPage
      this.search()
    },
    handleSizeChange(newSize) {
      this.queryInfo.baseParam.pageSize = newSize
      this.search()
    },
    handleControl(val, info) {
      if (val === '添加到沟通列表') {
        this.$confirm('确定添加到沟通列表吗?', '提示')
          .then(async () => {
            const { data: res } = await addToCommunication({
              personCode: info.personCode,
              projectId: this.id
            })

            if (res.resultCode === 200) {
              this.$message.success('添加成功')
              this.search()
            }
          })
          .catch(() => {})
      } else if (val === '查看详情') {
        this.$router.push({
          name: 'TalentMessageView',
          query: {
            id: info.personCode,
            clientType: 1,
            tabName: this.tabName,
            chidrenQueryInfo: JSON.stringify(this.queryInfo),
            positionType: this.positionType,
            projectId: this.id,
            searchInfo: JSON.stringify(this.searchInfo)
          }
        })
      } else if (val === '发起聊天') {
        console.log('发起聊天')
      }
    },
    // 所在城市
    searchCurrentArae(val) {
      this.queryInfo.personCountry = val.country
      this.queryInfo.personProvince = val.province
      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.queryInfo.personCity = val.city
      }
      this.resetPage()
      this.search()
    },
    resetPage() {
      this.queryInfo.baseParam.pageNum = 1
      this.queryInfo.baseParam.pageSize = 30
    },
    // 期望地点
    searchArae(val) {
      this.queryInfo.expectedCountry = val.country
      this.queryInfo.expectedProvince = val.province
      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.queryInfo.expectedCity = val.city
      }
      this.search()
    },
    onChange(val) {
      this.resetPage()
      this.queryInfo.workingYears = val
      this.search()
    },
    changePositionType(val) {
      this.resetPage()
      this.queryInfo.personTypes = val
      this.search()
    }
  }
}
</script>

<style lang="less" scoped>
.allSearch {
  .search-form {
    background: #fff;
    padding: 16px;
    /deep/ .el-form-item {
      margin-bottom: 5px;
    }
  }
  .search-input {
    display: flex;
    // justify-content: flex-end;
    margin-top: 15px;
    margin-left: 10px;
    .input-with-select {
      width: 300px;
      margin-right: 0;
      /deep/ .el-input-group__append {
        background: #17757a;
        border: 1px solid #17757a;
        color: #fff;
      }
    }
  }
  .talents {
    font-size: 14px;
    color: #333333;
    margin-bottom: 8px;
    display: flex;
    justify-content: flex-end;
    .total {
      color: #ffb847;
      padding: 0 3px;
    }
  }
  .talentProgress {
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 8px;
  }
}
</style>
